import { FunctionComponent } from 'react';
import * as s from './PetsItem.css';
import type * as T from './PetsItem.types';
import Picture from '@media-ui/core/src/components/Picture';
import Link from '@media-ui/core/src/components/Link';
import Text from '@media-ui/core/src/components/Text';
import plural from '@media-ui/core/src/tools/plural';
import { counterTrigger } from 'Src/tools/counters';
import classNames from 'classnames';
const PetsItem: FunctionComponent<T.IPetsItemProps> = (props) => {
    const { name, main_image, url, owners_count, clickCounter, clb, rating, isCompact, } = props;
    const handleLinkClick = () => {
        if (clickCounter) {
            counterTrigger(clickCounter);
        }
        if (clb) {
            counterTrigger('blockClick', {
                id: String(clb),
            });
        }
    };
    return (<div className={classNames(s.root, isCompact && s.compact)}>
      {main_image && (<div className={s.pictureWrapper}>
          <Picture className={s.picture} objectFit="cover" source={{ src: main_image }}/>
          {rating ? <span className={s.rating}>{rating}</span> : null}
        </div>)}
      {<div>
          {name && (<Link className={s.name} href={url} holder onClick={handleLinkClick}>
              {name}
            </Link>)}
          {owners_count && (<Text type="mediaCaption" color="secondary">
              {owners_count}{' '}
              {plural(owners_count, 'владелец', 'владельца', 'владельцев')}
            </Text>)}
        </div>}
    </div>);
};
export default PetsItem;
